export interface IStateMapping {
  // state - $state.current.name which is defined by different module
  [state: string]: string;
}

export class FeedbackConst {
  public experienceAreas = {
    // Comm Console
    comm: "https://servicedesk.uservoice.com/forums/601702",
    // Insights
    management: "https://servicedesk.uservoice.com/forums/601705",
    // Email
    email: "https://servicedesk.uservoice.com/forums/911149",
    // Case
    "customershell.case": "https://servicedesk.uservoice.com/forums/601699",
    // Knowledge
    knowledge: "https://servicedesk.uservoice.com/forums/911266",
    // Commercial Support Tool (CST)
    "customershell.cst": "https://servicedesk.uservoice.com/forums/911269",
    "customershell.commercial": "https://servicedesk.uservoice.com/forums/912085",
    // Agent Management
    "agentmgr.dashboard": "https://servicedesk.uservoice.com/forums/911305",
    // Privacy Care Tool (PCT)
    "customershell.privacy": "https://servicedesk.uservoice.com/forums/911284",
    // Device Management
    "customershell.devicemanagement": "https://servicedesk.uservoice.com/forums/911272",
    // Home
    home: "https://servicedesk.uservoice.com/forums/912085",
    // Default
    default: "https://servicedesk.uservoice.com/forums/912085"
  } as IStateMapping;
}
